import React from "react";
import UserAvatar from "../../../Components/CustomComponents/UserAvatar";
import { FaStar } from "react-icons/fa";

const renderStars = (rating) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(<FaStar key={i} color={i <= rating ? "#ffc107" : "#c8c8c8"} />);
  }
  return stars;
};

const VehicleReview = ({ data }) => {
  return (
    <div className="mb-2">
      <UserAvatar
        username={`${data?.user?.firstname} ${data?.user?.lastname}`}
        image_url={data?.user?.image_url}
      />
      <div className="d-flex my-2">{renderStars(data.ratings)}</div>
      <p className="">{data.review}</p>
    </div>
  );
};

export default VehicleReview;
